import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./DemoIntroKoop.css";
import { useTranslation, Trans } from "react-i18next";
import { Typography } from "@mui/material";
import { Box, Button, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const DemoIntroKoop = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));

  function handleNext() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/koopakte/upload${search}`);
  }

  return (
    <div className="mw-container" style={{ marginTop: 0 }}>
      <Typography
        variant="h3"
        gutterBottom
        sx={{
          fontSize: "32px",
          color: "#439BD9",
          fontWeight: 600,
          mb: 0,
        }}
      >
        {t("maatwerkIntro.title.purchase")}
      </Typography>

      <Divider />

      <Box
        id="form-container"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "65px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            flex: 1,
            minWidth: "320px",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#439BD9",
              marginBottom: "20px",
            }}
          >
            {t("maatwerkIntro.subtitleLeft")}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#454545",
              fontWeight: 400,
            }}
          >
            <Trans
              i18nKey="maatwerkIntro.textLeftTop"
              values={{
                title: t("maatwerkIntro.title.purchase"),
              }}
              components={{
                b: <b></b>,
                br: (
                  <>
                    <br />
                    <br />
                  </>
                ),
              }}
            />
          </Typography>
          {mobile && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF8C00",
                  color: "#fff",
                  borderRadius: "38px",
                  textTransform: "none",
                }}
                onClick={handleNext}
              >
                {t("maatwerkIntro.startDeDemo")}
              </Button>
            </Box>
          )}
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#454545",
              fontWeight: 400,
            }}
          >
            <Trans
              i18nKey="maatwerkIntro.textLeftBottom"
              components={{
                b: <b></b>,
                br: (
                  <>
                    <br />
                    <br />
                  </>
                ),
              }}
            />
          </Typography>
        </Box>
        <Box sx={{ flex: 1, minWidth: "320px" }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#439BD9",
              marginBottom: "20px",
            }}
          >
            {t("maatwerkIntro.subtitleRight")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            <Box sx={{ display: "flex", gap: "24px" }}>
              {/* icon */}
              <Box
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#439BD9",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "12px",
                }}
              >
                <svg
                  width="10"
                  height="13"
                  viewBox="0 0 10 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.66667 0C0.747396 0 0 0.728711 0 1.625V11.375C0 12.2713 0.747396 13 1.66667 13H8.33333C9.2526 13 10 12.2713 10 11.375V4.0625H6.66667C6.20573 4.0625 5.83333 3.69941 5.83333 3.25V0H1.66667ZM6.66667 0V3.25H10L6.66667 0ZM5.625 10.3594C5.625 10.6971 5.34635 10.9688 5 10.9688C4.65365 10.9688 4.375 10.6971 4.375 10.3594V7.76699L3.56771 8.5541C3.32292 8.79277 2.92708 8.79277 2.6849 8.5541C2.44271 8.31543 2.4401 7.92949 2.6849 7.69336L4.5599 5.86523C4.80469 5.62656 5.20052 5.62656 5.44271 5.86523L7.31771 7.69336C7.5625 7.93203 7.5625 8.31797 7.31771 8.5541C7.07292 8.79023 6.67708 8.79277 6.4349 8.5541L5.6276 7.76699L5.625 10.3594Z"
                    fill="white"
                  />
                </svg>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ lineHeight: "1.8", fontSize: "16px", fontWeight: 400 }}
                >
                  <b>Upload</b>
                  <br />
                  {t("maatwerkIntro.Uploadtext.purchase")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "24px" }}>
              {/* icon */}
              <Box
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#439BD9",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "12px",
                }}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.62416 4.87583C8.62416 3.8811 8.22911 2.92711 7.52592 2.22373C6.82272 1.52035 5.86899 1.12519 4.87452 1.12519C3.88006 1.12519 2.92633 1.52035 2.22313 2.22373C1.51994 2.92711 1.12489 3.8811 1.12489 4.87583C1.12489 5.87056 1.51994 6.82455 2.22313 7.52794C2.92633 8.23132 3.88006 8.62647 4.87452 8.62647C5.86899 8.62647 6.82272 8.23132 7.52592 7.52794C8.22911 6.82455 8.62416 5.87056 8.62416 4.87583ZM7.90001 8.69914C7.0704 9.35785 6.01816 9.75167 4.87452 9.75167C2.18182 9.75167 0 7.56926 0 4.87583C0 2.1824 2.18182 0 4.87452 0C7.56723 0 9.74905 2.1824 9.74905 4.87583C9.74905 6.01978 9.35534 7.0723 8.69681 7.90213L11.8348 11.0409C12.0551 11.2613 12.0551 11.6176 11.8348 11.8356C11.6145 12.0536 11.2583 12.056 11.0403 11.8356L7.90001 8.69914Z"
                    fill="white"
                  />
                </svg>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ lineHeight: "1.8", fontSize: "16px", fontWeight: 400 }}
                >
                  <b>{t("maatwerkIntro.Herkenning")}</b>
                  <br />
                  {t("maatwerkIntro.Herkenningtext")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "24px" }}>
              {/* icon */}
              <Box
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#439BD9",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "12px",
                  paddingLeft: "2px",
                }}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.55556 10.875H6.91493C7.2066 11.3062 7.5809 11.6836 8.01597 11.9836C7.93819 11.9953 7.86042 12 7.78021 12H1.55556C0.697569 12 0 11.3273 0 10.5V1.5C0 0.672656 0.697569 0 1.55556 0H5.57813C5.99132 0 6.3875 0.157031 6.67917 0.438281L8.87882 2.55937C9.17049 2.84062 9.33333 3.22266 9.33333 3.62109V4.65469C8.91528 4.76953 8.52153 4.94297 8.16667 5.16562V3.74766H6.22222C5.79201 3.74766 5.44444 3.4125 5.44444 2.99766V1.12266L1.55556 1.125C1.34167 1.125 1.16667 1.29375 1.16667 1.5V10.5C1.16667 10.7063 1.34167 10.875 1.55556 10.875ZM10.5 5.25C11.4283 5.25 12.3185 5.60558 12.9749 6.23851C13.6313 6.87145 14 7.72989 14 8.625C14 9.52011 13.6313 10.3785 12.9749 11.0115C12.3185 11.6444 11.4283 12 10.5 12C9.57174 12 8.6815 11.6444 8.02513 11.0115C7.36875 10.3785 7 9.52011 7 8.625C7 7.72989 7.36875 6.87145 8.02513 6.23851C8.6815 5.60558 9.57174 5.25 10.5 5.25ZM10.5 10.875C10.6547 10.875 10.8031 10.8157 10.9125 10.7102C11.0219 10.6048 11.0833 10.4617 11.0833 10.3125C11.0833 10.1633 11.0219 10.0202 10.9125 9.91475C10.8031 9.80926 10.6547 9.75 10.5 9.75C10.3453 9.75 10.1969 9.80926 10.0875 9.91475C9.97813 10.0202 9.91667 10.1633 9.91667 10.3125C9.91667 10.4617 9.97813 10.6048 10.0875 10.7102C10.1969 10.8157 10.3453 10.875 10.5 10.875ZM10.5 6.375C10.2861 6.375 10.1111 6.54375 10.1111 6.75V8.625C10.1111 8.83125 10.2861 9 10.5 9C10.7139 9 10.8889 8.83125 10.8889 8.625V6.75C10.8889 6.54375 10.7139 6.375 10.5 6.375Z"
                    fill="white"
                  />
                </svg>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ lineHeight: "1.8", fontSize: "16px", fontWeight: 400 }}
                >
                  <b>{t("maatwerkIntro.Resultaten")}</b>
                  <br />
                  {t("maatwerkIntro.Resultatentext")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "24px" }}>
              {/* icon */}
              <Box
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#439BD9",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "12px",
                }}
              >
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.42501 3.24234L6 1.26119L10.575 3.24234C10.7225 3.30617 10.8025 3.44148 10.8 3.56913C10.79 5.90259 9.83999 9.93382 6.1425 11.7414C6.0525 11.7848 5.9475 11.7848 5.86 11.7414C2.16001 9.93126 1.21251 5.90259 1.20001 3.56657C1.20001 3.43892 1.27751 3.30617 1.42501 3.23979V3.24234ZM11.0425 2.1139L6.335 0.0740377C6.23 0.0255302 6.1175 0 6 0C5.8825 0 5.77 0.0255302 5.665 0.0740377L0.957509 2.1139C0.407511 2.35134 -0.00248862 2.90534 1.13712e-05 3.57423C0.0125113 6.10683 1.03251 10.7406 5.34 12.8468C5.7575 13.0511 6.2425 13.0511 6.66 12.8468C10.97 10.7406 11.9875 6.10683 12 3.57423C12.0025 2.90534 11.5925 2.35134 11.0425 2.1139ZM8.82499 5.33582C9.05999 5.09584 9.05999 4.70778 8.82499 4.47035C8.58999 4.23291 8.21 4.23036 7.9775 4.47035L5.2025 7.3042L4.0275 6.10428C3.7925 5.8643 3.4125 5.8643 3.18001 6.10428C2.94751 6.34427 2.94501 6.73233 3.18001 6.96976L4.78 8.60369C5.015 8.84368 5.395 8.84368 5.6275 8.60369L8.82499 5.33582Z"
                    fill="white"
                  />
                </svg>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ lineHeight: "1.8", fontSize: "16px", fontWeight: 400 }}
                >
                  <b>{t("maatwerkIntro.Controle")}</b>
                  <br />
                  {t("maatwerkIntro.Controletext")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF8C00",
            color: "#fff",
            borderRadius: "38px",
            textTransform: "none",
          }}
          onClick={handleNext}
        >
          {t("maatwerkIntro.startDeDemo")}
        </Button>
      </Box>
    </div>
  );
};

export default DemoIntroKoop;
